import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import ContentHero from "@components/ContentHero"
import parseContentImages, { ParseContentImagesProps } from "@utils/parseContentImages"

const StrapiContentHero = ({
    content,
    content_images: contentImages,
    backgroundImage,
    read_more: readMore
}: GatsbyTypes.ContentHeroFragment) => {
    const bgImage = backgroundImage?.file?.childImageSharp?.gatsbyImageData
        ? <GatsbyImage loading="eager" image={backgroundImage.file.childImageSharp.gatsbyImageData} alt={`${backgroundImage?.alternativeText}`} />
        : undefined

    return <ContentHero
        isArticle={readMore}
        content={parseContentImages(
            content,
            contentImages as ParseContentImagesProps[]
        )}
        backgroundImage={bgImage}
    />
}

export default StrapiContentHero
